import React from 'react';

const FeaturesBanner = () => {
  const features = [
    "Gestão de alunos",
    "Gestão de pagamento",
    "Gestão de turmas",
    "Avaliação técnica",
    "Avaliação de desempenho",
    "Planejamento automático de objetivos",
    "Automação de envio de mensagens CRM",
    "Integração com IA",
    "Dashboards intuitivos",
    "Gameficação"
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(90deg, #151822 0%, #2a3042 50%, #151822 100%)', 
      padding: '30px 0', 
      overflow: 'hidden', 
      borderTop: '1px solid rgba(0, 243, 255, 0.3)', 
      borderBottom: '1px solid rgba(0, 243, 255, 0.3)',
      boxShadow: '0 5px 20px rgba(0,0,0,0.4), inset 0 0 30px rgba(0,0,0,0.4)'
    }}>
      {/* Contêiner principal do marquee */}
      <div 
        style={{ 
          display: 'flex', 
          width: 'fit-content',
          animation: 'scrollBanner 40s linear infinite'
        }}
      >
        {/* Renderizamos o conjunto duas vezes. O track inteiro vai até -50% (que equivale a um conjunto inteiro) */}
        {[1, 2].map((key) => (
          <div key={key} style={{ display: 'flex' }}>
            {features.map((feature, index) => {
              const words = feature.split(' ');
              const firstWord = words[0];
              const restText = words.slice(1).join(' ');

              return (
                <div 
                  key={index} 
                  className="d-flex align-items-center text-white text-uppercase position-relative" 
                  style={{ 
                    fontSize: '0.95rem', 
                    letterSpacing: '2px', 
                    fontWeight: '500', 
                    margin: '0 50px',
                    whiteSpace: 'nowrap',
                    padding: '10px 0'
                  }}
                >
                  {/* Palavra de fundo outline (sombra parecida com a Hero) */}
                  <div 
                    className="position-absolute"
                    style={{
                      fontSize: '3rem', 
                      fontWeight: '800',
                      color: 'transparent',
                      WebkitTextStroke: '1px rgba(0, 243, 255, 0.25)', 
                      top: '50%',
                      left: '35px', 
                      transform: 'translateY(-50%)',
                      zIndex: 0,
                      pointerEvents: 'none',
                      userSelect: 'none',
                      letterSpacing: '4px'
                    }}
                  >
                    {firstWord}
                  </div>

                  {/* Conteúdo à frente */}
                  <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <span>
                      <strong style={{ 
                        fontSize: '1.15rem', 
                        fontWeight: '700',
                        textShadow: '0 0 8px rgba(0, 243, 255, 0.3), 2px 2px 4px rgba(0,0,0,0.4)',
                        marginRight: '6px'
                      }}>
                        {firstWord}
                      </strong>
                      {restText}
                    </span>
                    {/* Traço azul abaixo do texto principal */}
                    <div style={{ 
                      marginTop: '6px',
                      width: '40px', 
                      height: '3px', 
                      backgroundColor: '#00f3ff', 
                      boxShadow: '0 0 8px #00f3ff, 0 0 15px rgba(0, 243, 255, 0.6)',
                      borderRadius: '2px'
                    }}></div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      
      <style>
        {`
          @keyframes scrollBanner {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); } 
          }
        `}
      </style>
    </div>
  );
};

export default FeaturesBanner;
